import Geometry from "@arcgis/core/geometry/Geometry";
import Point from "@arcgis/core/geometry/Point";
import Polyline from "@arcgis/core/geometry/Polyline";
import Polygon from "@arcgis/core/geometry/Polygon";

export const isEmptyGeometry = (geom: Geometry | null | undefined): boolean => {
  if (!geom) return true;

  if (geom.type === "point") {
    const { x, y } = geom as Point;
    return x == null || y == null || isNaN(x) || isNaN(y);
  }

  if (geom.type === "polyline") {
    const { paths } = geom as Polyline;
    return !paths?.length || paths.every((p) => !p?.length);
  }

  if (geom.type === "polygon") {
    const { rings } = geom as Polygon;
    return !rings?.length || rings.every((r) => !r?.length);
  }

  return true;
};
